import * as z$1 from "zod/v4";
//#region src/schemas/http/space-link-previews.ts
const MAX_MESSAGE_LINK_PREVIEWS = 12;
const previewUrlSchema = z$1.url().max(4096).refine((value) => {
	const url = new URL(value);
	return ["https:", "http:"].includes(url.protocol) && !url.username && !url.password;
});
const previewImageSchema = z$1.string().max(35e4).regex(/^data:image\/(?:png|jpeg|webp|gif|x-icon|vnd\.microsoft\.icon);base64,[A-Za-z0-9+/=]+$/).nullable();
const getSpaceLinkPreviewsInputSchema = z$1.object({
	spaceId: z$1.string().regex(/^[0-9a-f]{64}$/),
	signalId: z$1.string().min(1).max(256)
}).strict();
const spaceMessageLinksSchema = z$1.object({
	signalId: z$1.string(),
	revision: z$1.number().int().nonnegative(),
	urls: z$1.array(previewUrlSchema).max(12)
}).strict();
const linkPreviewSchema = z$1.object({
	url: previewUrlSchema,
	title: z$1.string().max(300).nullable(),
	description: z$1.string().max(500).nullable(),
	siteName: z$1.string().max(100).nullable(),
	image: previewImageSchema,
	icon: previewImageSchema,
	status: z$1.enum(["available", "unavailable"])
}).strict();
const getSpaceLinkPreviewsResponseSchema = z$1.object({
	signalId: z$1.string(),
	revision: z$1.number().int().nonnegative(),
	previews: z$1.array(linkPreviewSchema).max(12)
}).strict();
//#endregion
export { MAX_MESSAGE_LINK_PREVIEWS, getSpaceLinkPreviewsInputSchema, getSpaceLinkPreviewsResponseSchema, linkPreviewSchema, spaceMessageLinksSchema };

//# sourceMappingURL=space-link-previews.js.map